import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import moment from 'moment';
import { withStyles, Card, CardContent, CircularProgress, Grid } from '@material-ui/core';
import { Delete, KeyboardArrowDown as DownIcon, KeyboardArrowUp as UpIcon } from '@material-ui/icons';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { withRouter } from 'react-router-dom';

class TicketHistoryMessage extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        ticketHistory: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        deleteLoading: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        rightDeleteTicketHistory: PropTypes.bool,
        ticketHistoryId: PropTypes.number.isRequired,
        deleteFheTicketHistory: PropTypes.func,
    };

    static defaultProps = {
        deleteLoading: '',
        rightDeleteTicketHistory: false,
        deleteFheTicketHistory: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    expandDeletedTicketHistory = () => {
        const { expanded } = this.state;
        if (expanded === true) {
            this.setState({
                expanded: false,
            });
        } else {
            this.setState({
                expanded: true,
            });
        }
    };

    render() {
        const { classes, ticketHistory, deleteFheTicketHistory, ticketHistoryId, deleteLoading, rightDeleteTicketHistory, history } = this.props;
        const { expanded } = this.state;
        const isTicketFhe = ticketHistory.userType === 'fhe';

        const time = moment(ticketHistory.createdAt, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');

        return (
            <div className={classes.ticketContainer}>
                <Grid container justify={isTicketFhe ? 'flex-end' : 'flex-start'}>
                    <Grid container spacing={1} item sm={12}>
                        <Card
                            onClick={ticketHistory.deletedAt ? this.expandDeletedTicketHistory : null}
                            className={`${classes.cardClass} ${
                                ticketHistory.deletedAt ? classes.backgroundColorRed100 : classes.backgroundColorTeal100
                            }`}
                        >
                            <CardContent>
                                <div className={classes.createdAt}>
                                    {Translator.translate('general.ticketing.createdAt')} {time}
                                </div>
                                <div className="creator">
                                    {ticketHistory.creator === 'undefinedCreator'
                                        ? Translator.translate(`generic.ticketing.listing.undefinedCreator`)
                                        : ticketHistory.creator}
                                </div>
                                {ticketHistory.deletedAt ? (
                                    <Fragment>
                                        {expanded ? (
                                            <Fragment>
                                                <div className={classes.colorRed500}>
                                                    {Translator.translate(
                                                        'general.ticketing.deletedAt',
                                                        moment(ticketHistory.deletedAt, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'),
                                                        moment(ticketHistory.deletedAt, 'DD/MM/YYYY HH:mm:ss').format('HH:mm'),
                                                    )}
                                                </div>
                                                <div className={classes.description}>{ticketHistory.description}</div>
                                                <div className={classes.expandDeletedTicket}>
                                                    <UpIcon />
                                                </div>
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                <div className={classes.colorRed500}>
                                                    {Translator.translate(
                                                        'general.ticketing.deletedAt',
                                                        moment(ticketHistory.deletedAt, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'),
                                                        moment(ticketHistory.deletedAt, 'DD/MM/YYYY HH:mm:ss').format('HH:mm'),
                                                    )}
                                                </div>
                                                <div className={classes.expandDeletedTicket}>
                                                    <DownIcon />
                                                </div>
                                            </Fragment>
                                        )}
                                    </Fragment>
                                ) : (
                                    <div className={classes.description}>{ticketHistory.description}</div>
                                )}

                                {!ticketHistory.deletedAt && rightDeleteTicketHistory && (
                                    <span>
                                        {typeof deleteFheTicketHistory === 'function' && (
                                            <div
                                                role="presentation"
                                                className={`${classes.deleteIcon} ${classes.colorGrey}`}
                                                onClick={deleteFheTicketHistory && deleteFheTicketHistory.bind(this, ticketHistoryId)}
                                            >
                                                {deleteLoading !== ticketHistoryId ? <Delete /> : <CircularProgress size={20} />}
                                            </div>
                                        )}
                                    </span>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const styles = theme => ({
    cardClass: {
        width: '100%',
        position: 'relative',
    },
    ticketContainer: {
        margin: '15px 0',
    },
    expandDeletedTicket: {
        cursor: 'pointer',
        position: 'absolute',
        fontSize: '0.8em',
        top: 5,
        right: 20,
        color: theme.palette.colors.grey600,
    },

    description: {
        whiteSpace: 'pre-line',
    },

    deleteIcon: {
        cursor: 'pointer',
        position: 'absolute',
        fontSize: '0.8em',
        top: 5,
        right: 20,
    },
    colorGrey: {
        color: theme.palette.colors.grey600,
    },
    colorRed500: {
        color: theme.palette.colors.red500,
    },
    backgroundColorTeal100: {
        backgroundColor: theme.palette.colors.teal100,
    },
    backgroundColorRed100: {
        backgroundColor: theme.palette.colors.red100,
        cursor: 'pointer',
    },

    createdAt: {
        position: 'absolute',
        fontSize: '0.8em',
        bottom: -22,
        right: 15,
    },

    deletedAt: {
        position: 'absolute',
        fontSize: '0.8em',
        top: -22,
        right: 15,
    },

    creator: {
        position: 'absolute',
        fontSize: '0.9em',
        top: -22,
        left: 15,
    },
});

export default withRouter(renderEnvComponent('components/TicketHistoryMessage', withStyles(styles, { withTheme: true })(TicketHistoryMessage)));



// WEBPACK FOOTER //
// ./environments/genericEnv/components/TicketHistoryMessage.js